import React from 'react';
import { useTheme } from 'styled-components';

import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ className, onClick }, ref) {
  const { colors } = useTheme();

  return (
    <svg
      ref={ref}
      onClick={onClick}
      width='10px'
      height='100%'
      viewBox='0 0 10 53'
      version='1.1'
      className={className}
      preserveAspectRatio='none'>
      <defs>
        <polygon id='path-1' points='386 363 1292 363 1292 416 386 416 376 389.5' />
        <filter x='-0.4%' y='-3.8%' width='100.9%' height='115.1%' filterUnits='objectBoundingBox' id='filter-2'>
          <feOffset dx='0' dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
          <feGaussianBlur stdDeviation='1' in='shadowOffsetOuter1' result='shadowBlurOuter1' />
          <feColorMatrix
            values='0 0 0 0 0.239216   0 0 0 0 0.345098   0 0 0 0 0.501961  0 0 0 0.05 0'
            type='matrix'
            in='shadowBlurOuter1'
          />
        </filter>
      </defs>
      <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='FOLLOW-THIS-Copy-4' transform='translate(-376.000000, -363.000000)'>
          <g id='Rectangle-5-Copy-50'>
            <use fill={colors.grey00_5} fillOpacity='1' filter='url(#filter-2)' xlinkHref='#path-1' />
            <use fill={colors.grey00_5} fillRule='evenodd' xlinkHref='#path-1' />
          </g>
        </g>
      </g>
    </svg>
  );
});

export default React.memo(Icon);
